<template>
<div class="navbar-menu">
  <div class="navbar-start" >
    <div class="navbar-item is-hidden-touch" v-if="title && subtitle">
      <navbar-info v-if="title" :title="title" :info="subtitle" />
    </div>
    <router-link v-for="(link, index) in links" class="navbar-item"
      :class="{'is-active': isActive(link) }" :to="link.to"
      :key="index">
      {{ link.title }}
    </router-link>
  </div>
</div>
</template>

<script>
import NavbarInfo from '@/components/navbar/navbar-info'

export default {
  components: { NavbarInfo },
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    links: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isActive ({ to }) {
      const active = this.$route.fullPath === to
      if (active) { return true }
      if (this.$route.fullPath === '/' && to === '/jobs') {
        return true
      }
      return this.$route.fullPath.includes(`${to}/`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar.is-white .navbar-start > a.navbar-item.is-active {
  font-weight: bold;
  background-color: inherit;
}
a.navbar-item:hover,
a.navbar-item.is-active,
.navbar-item,
.navbar-link:hover,
.navbar-link.is-active {
  color: #111;
  background-color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/navbar-items.vue